import React, { useState } from "react";
import { View, Image, StyleSheet } from "react-native";
import { BACKGROUND_COLORS, BORDER_COLORS } from "../../style/colors.js";

const ImageComponent = ({ data }) => {
  const defaultImageUri = require("../../assets/noFound.png");
  const [imageUri, setImageUri] = useState(data.image);

  const handleError = () => {
    setImageUri(defaultImageUri);
  };

  return (
    <View style={styles.imageContainer}>
      <Image
        style={styles.image}
        source={{ uri: imageUri }}
        onError={handleError}
      />
    </View>
  );
};

export default ImageComponent;

const styles = StyleSheet.create({
  imageContainer: {
    flex: 1,
    backgroundColor: BACKGROUND_COLORS.CARD,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: BORDER_COLORS.LIGHT,
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    resizeMode: "contain",
  },
});
